import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { ErrorForApiModel } from '@models/error-handling/error-for-api.model';

@Injectable({
  providedIn: 'root',
})
export class EventLoggingService {
  private errorUrl = `${this.appConfigService.apiUrl}/application/log/exception`;

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient,
  ) {
  }

  recordError(errorForApi: ErrorForApiModel): void {
    this.http.post(this.errorUrl, errorForApi).subscribe();
  }

}
